import classNames from 'classnames'
import type { ReactNode } from 'react'
import { Component } from 'react'
import type { WithStyles } from 'react-jss'
import withStyles from 'react-jss'
import { NavLink } from 'react-router-dom'
import type { LinkTrackingInfo } from '../../../modules/analytics/models'
import type { SaladTheme } from '../../../SaladTheme'
import { getStore } from '../../../Store'
import { SmartLink } from '../../SmartLink'

const styles = (theme: SaladTheme) => ({
  menuTitle: {
    fontFamily: theme.fontGroteskBook25,
    fontSize: theme.small,
    lineHeight: theme.small,
    letterSpacing: '0.01rem',
    fontWeight: 'normal',
    color: theme.green,

    '& a': {
      color: 'inherit',
      textDecoration: 'none',

      '&:hover, &:active, &.active': {
        color: `${theme.lightGreen}`,
      },
    },
  },
  disabledItem: {
    '& a, & p': {
      paddingBottom: 12,
      opacity: '0.5 !important',
      cursor: 'not-allowed !important',
      '&:hover, &:active, &.active': {
        // color: 'blue !important',
        opacity: '0.2 !important',
      },
    },
  },
})

interface Props extends WithStyles<typeof styles> {
  path?: string
  className?: string
  enabled?: boolean
  externalLink?: boolean
  trackingInfo?: LinkTrackingInfo
  children?: ReactNode
}

interface State {
  toggle: boolean
}

const handleClickTracking = (to?: string, trackingInfo?: any) => {
  if (to) {
    const store = getStore()
    store.analytics.trackSmartLink(to, trackingInfo.label, trackingInfo.type)
  }
}

class _MenuTitle extends Component<Props, State> {
  public override state = {
    toggle: false,
  }

  toggleActive = () => {
    this.setState({
      toggle: !this.state.toggle,
    })
  }

  public override render(): ReactNode {
    const { path, children, className, classes, enabled, externalLink, trackingInfo } = this.props

    const elements = path ? (
      <label
        className={classNames(`menuTitle ${classes.menuTitle}`, className, {
          [classes.disabledItem]: enabled === false,
        })}
      >
        {externalLink ? (
          <SmartLink to={path} trackingInfo={trackingInfo}>
            {children}
          </SmartLink>
        ) : enabled !== false ? (
          <NavLink
            to={path}
            activeClassName="active"
            onClick={trackingInfo ? () => handleClickTracking(path, trackingInfo) : undefined}
          >
            {children}
          </NavLink>
        ) : (
          <p>{children}</p>
        )}
      </label>
    ) : (
      <label className={classNames(`menuTitle ${classes.menuTitle}`, className)}>{children}</label>
    )

    return <>{elements}</>
  }
}

export const MenuTitle = withStyles(styles)(_MenuTitle)
